import React, { ReactNode } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { SummarizeTask } from 'shared/types/task';

interface TaskRowProps {
  task: SummarizeTask;
  index: number;
  tasksLength: number;
  handleTaskPositionChange: (id: string, newIndex: number) => void;
  updateICL: boolean;
  disabled?: boolean;
  t: (key: string) => string;
  children: ReactNode;
}

const TaskRow = ({ task, index, tasksLength, handleTaskPositionChange, t, children, disabled }: TaskRowProps) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-center">
        <p className="!mb-0 !mr-2 text-base font-bold lg:text-lg">{t('reorderTask')}</p>
        <FormControl size="small" sx={{ width: 80 }}>
          <Select
            disabled={disabled}
            value={index + 1}
            onChange={e => handleTaskPositionChange(task.id, Number(e.target.value))}
            MenuProps={{ disablePortal: true }}
          >
            {[...Array(tasksLength)].map((_, i) => (
              <MenuItem key={i} value={i + 1}>
                {i + 1}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {children}
    </div>
  );
};
export default TaskRow;
